// src/data/quizzes.js
export const quizzes = [
    {
      id: 0,
      title: 'Sample Quiz',
      questions: [
        {
          question: 'What is the capital of France?',
          options: ['Paris', 'London', 'Berlin', 'Madrid'],
          correct: 'Paris',
        },
        {
          question: 'Which is the largest planet in our solar system?',
          options: ['Earth', 'Jupiter', 'Saturn', 'Mars'],
          correct: 'Jupiter',
        },
      ],
    },
  ];
  